// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b9e5b221","977":"40c19de2"}[chunkId] + ".chunk.js";
};